// Copyright (C) 2017-2023 Smart code 203358507

const DragAndDrop = require('./DragAndDrop');

module.exports = DragAndDrop;
